module.exports = __webpack_public_path__ + "04_mole.26553889.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer2/04_mole.png
// module id = jiWA
// module chunks = 0